import '../scss/app.scss'
import 'bootstrap'
import navigation from './modules/navigation'
import Sliders from './modules/sliders'
import faq from './modules/faq'
import productGallery from './modules/product-gallery'
import applicationsGallery from './modules/applications-gallery'
import productMenu from './modules/product-menu'
import applicationsMenu from './modules/applications-menu'
import docModal from './modules/doc-modal'
import ContactsMap from './modules/contacts-map'
import imageCar from './modules/image-car'
import countrySelects from './modules/country-selects'
import newTabLinks from './modules/new-tab-links'

class App {
    constructor() {
        navigation()
        newTabLinks()
        this.productHeights()
        if (document.querySelector('.content-faq')) faq()
        if (document.querySelector('[data-product-gallery]')) productGallery()
        if (document.querySelector('[data-applications-gallery]')) applicationsGallery()
        if (document.querySelector('[data-menu-product]')) productMenu()
        if (document.querySelector('[data-menu-applications]')) applicationsMenu()
        if (document.querySelector('[data-doc-modal]')) docModal()
        if (document.getElementById('contacts-map')) new ContactsMap().init()
        if (document.querySelector('[data-image-car]')) imageCar()
        countrySelects()
        if (!document.querySelector('.splide')) return
        const sliders = new Sliders()
        if (document.querySelector('[data-hero-splide]')) sliders.hero()
        if (document.querySelector('[data-tech-splide]')) sliders.tech()
        if (document.querySelector('[data-applications-splide]')) sliders.applications()
        if (document.querySelector('[data-case-studies-splide]')) sliders.caseStudies()
        if (document.querySelector('[data-partner-splide]')) sliders.partner()
        if (document.querySelector('[data-product-splide]')) sliders.product()
        if (document.querySelector('[data-related-splide]')) sliders.related()
        if (document.querySelector('[data-domain-splide]')) sliders.domain()
        if (document.querySelector('[data-working-splide]')) sliders.working()
        if (document.querySelector('[data-card-splide]')) sliders.card()
    }

    productHeights() {
        const menu = document.querySelector('[data-menu-product]')
        if (!menu) return
        const root = document.documentElement
        const set = () => {
            root.style.setProperty('--menu-product-height', `${menu.offsetHeight}px`)
        }
        set()
        new ResizeObserver(set).observe(menu)
    }
}

new App()
